function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 44.64,
    height: 27.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.743
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 13.715,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27.43,
    width: 44.64,
    height: 28.18,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.025714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 41.519999999999996,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.61,
    width: 44.64,
    height: 34.21,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 72.715,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.82,
    width: 44.64,
    height: 38.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.656000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 108.96,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.09,
    width: 44.64,
    height: 50.33,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 153.255,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 178.43,
    width: 44.64,
    height: 53.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 205.33,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 232.23,
    width: 44.64,
    height: 54.4,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 259.43,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 286.63,
    width: 44.64,
    height: 59.38,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 316.32,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.01,
    width: 44.64,
    height: 61.64,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 376.83,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.64,
    width: 44.64,
    height: 71.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 443.28,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.92,
    width: 44.64,
    height: 71.51,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 514.6750000000001,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 550.43,
    width: 44.64,
    height: 74.29,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 587.5749999999999,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 624.73,
    width: 44.64,
    height: 75.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.32,
    y: 662.365,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 0,
    width: 55.69,
    height: 60.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.485,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.32,
    y: 0,
    width: 58.07,
    height: 60.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.452222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.355,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.4,
    y: 0,
    width: 60.96,
    height: 60.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.654285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.88,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.36,
    y: 0,
    width: 62.35,
    height: 60.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.53500000000003,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.71,
    y: 0,
    width: 64.01,
    height: 60.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.715,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.72,
    y: 0,
    width: 64.13,
    height: 60.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.096666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.785,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.85,
    y: 0,
    width: 67.18,
    height: 60.58,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.44000000000005,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.03,
    y: 0,
    width: 69.29,
    height: 60.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.096666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.67499999999995,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 0,
    width: 70.96,
    height: 60.58,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.8000000000001,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.27,
    y: 0,
    width: 82.73,
    height: 60.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.19333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.635,
    y: 30.29,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 60.58,
    width: 71.67,
    height: 72.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.95875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 96.785,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 132.99,
    width: 71.67,
    height: 75.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 170.53,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 208.07,
    width: 71.67,
    height: 75.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.95875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 245.845,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 283.62,
    width: 71.67,
    height: 78.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.23857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 322.97,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 362.32,
    width: 71.67,
    height: 79.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 402.065,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 441.81,
    width: 71.67,
    height: 81.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 482.8,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 523.79,
    width: 71.67,
    height: 87.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.23857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 567.6899999999999,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.64,
    y: 611.59,
    width: 71.67,
    height: 88.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.475,
    y: 655.7950000000001,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 60.58,
    width: 76.91,
    height: 86.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.765,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.22,
    y: 60.58,
    width: 77.69,
    height: 86.07,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.098571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.065,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.91,
    y: 60.58,
    width: 78.04,
    height: 86.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.671111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.93,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.95,
    y: 60.58,
    width: 78.9,
    height: 86.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.4,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.85,
    y: 60.58,
    width: 80.03,
    height: 86.07,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.00375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.865,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.89,
    y: 60.58,
    width: 92.85,
    height: 86.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.75875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.3149999999999,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.74,
    y: 60.58,
    width: 99.26,
    height: 86.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.5175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.37,
    y: 103.615,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 146.65,
    width: 95.85,
    height: 100.61,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.692857142857141
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.235,
    y: 196.955,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 247.25,
    width: 95.85,
    height: 102.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.235,
    y: 298.395,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 349.54,
    width: 95.85,
    height: 108.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.692857142857141
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.235,
    y: 404,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 458.47,
    width: 95.85,
    height: 112.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.649999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.235,
    y: 514.88,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 571.29,
    width: 95.85,
    height: 128.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.235,
    y: 635.645,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.16,
    y: 146.65,
    width: 115.78,
    height: 111.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.95142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.05,
    y: 202.48000000000002,
    fontFamily: "Arial"
  }, "\n        De_Soto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.95,
    y: 146.65,
    width: 117.05,
    height: 111.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.166
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.47499999999997,
    y: 202.48000000000002,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 146.65,
    width: 117.53,
    height: 111.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.765,
    y: 202.48000000000002,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.53,
    y: 146.65,
    width: 137.47,
    height: 111.66,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.95142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.265,
    y: 202.48000000000002,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.16,
    y: 258.31,
    width: 125.11,
    height: 141.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.715,
    y: 329.095,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.16,
    y: 399.88,
    width: 125.11,
    height: 143.69,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.63875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.715,
    y: 471.725,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.16,
    y: 543.57,
    width: 125.11,
    height: 156.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.63875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.715,
    y: 621.7850000000001,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.28,
    y: 258.31,
    width: 153.84,
    height: 130.07,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.5175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.2,
    y: 323.345,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.11,
    y: 258.31,
    width: 208.89,
    height: 130.07,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.5175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.5550000000001,
    y: 323.345,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.28,
    y: 388.38,
    width: 133.29,
    height: 311.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.92499999999995,
    y: 544.19,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.56,
    y: 388.38,
    width: 229.44,
    height: 311.62,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 45.888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.28,
    y: 544.19,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.2fbb7cc62012378cc79b6dd3dce0dd1e.svg";
export { ForwardRef as ReactComponent };